module.exports = __webpack_public_path__ + "static/media/JohanaMedinaLeon.4808bc16.png";